// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ClerkReact from "@clerk/clerk-react";
import * as Navigation$FeedSync from "./Navigation.bs.mjs";

function Layout(Props) {
  var activeNavItem = Props.activeNavItem;
  var childrenOpt = Props.children;
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  var userId = window.ENV.userId;
  return React.createElement("div", {
              className: CSS$MakerDs.prefix("flex flex-row h-screen")
            }, React.createElement("div", {
                  className: CSS$MakerDs.prefix("flex-shrink border-r border-gray-200")
                }, React.createElement("div", {
                      className: CSS$MakerDs.prefix("w-60 p-5")
                    }, React.createElement(Navigation$FeedSync.make, {
                          active: activeNavItem
                        }))), React.createElement("div", {
                  className: CSS$MakerDs.prefix("flex-grow p-4 overflow-y-scroll relative")
                }, React.createElement("div", {
                      className: CSS$MakerDs.prefix("flex justify-end items-center gap-2 pb-8")
                    }, React.createElement("span", {
                          className: CSS$MakerDs.prefix("text-sm text-gray-600 font-medium flex")
                        }, (userId == null) ? React.createElement(React.Fragment, undefined, React.createElement(ClerkReact.OrganizationSwitcher, {
                                    hidePersonal: true
                                  }), React.createElement(ClerkReact.UserButton, {})) : "Account ID #" + userId + "")), React.createElement("div", {
                      className: CSS$MakerDs.prefix("mt-5")
                    }, children)));
}

var make = Layout;

export {
  make ,
}
/* react Not a pure module */
